import areaChartReducers from './chart-reducers/chartReducers.js';
import { combineReducers } from 'redux';
import notificationReducers from './notificationReducers.js';
// import toggleMenu from './menuReducers.js';
import tableReducers from './tableReducers.js';
import lineChartReducers from './chart-reducers/lineChartReducers.js';
import tinyChartReducers from './chart-reducers/tinyChartReducers.js';
// import productTableReducers from './productTableReducers.js';
// import productsReducers from './productReducers.js';
// import teamReducres from './teamReducres.js';
// import serviceReducers from './serviceReducers.js';
// import blogReducers from './blogReducers.js';
import headerStyleReducers from './style-switcher-reducers/headerStyleReducers.js';
import headerActiveStyleReducer from './style-switcher-reducers/headeractiveReducer.js';
import sidebarStyleReducers from './style-switcher-reducers/sidebarStyleReducers.js';
import sidebarActiveStyleReducer from './style-switcher-reducers/sidebarActiveReducer.js';
import headerBannerStyleReducers from './style-switcher-reducers/headerBannerStyleReducers.js';
import headerBannerActiveStyleReducer from './style-switcher-reducers/headerBannerActiveReducer.js';

// scheduling reducer
import schedulingReducer from './../modules/scheduling/reducers/SchedulingReducer.js';
// patient reducer
import patientReducer from './../modules/patients/reducers/PatientReducer.js';
// import quickPatientReducer from './../modules/quick/reducers/PatientReducer.js';

import { reducer as formReducer } from 'redux-form'; // SAYING use redux form reducers as reducers

import loginReducer from './../modules/logins/reducers/LoginReducer';

// user Reducer
import userReducer from './../modules/users/reducers/UserReducer';
// clearingHouseReducer
import clearingHouseReducer from './../modules/clearing-house/reducers/ClearingHouseReducers';
import superAdminClearingHouseReducer from './../modules/Superadmin/components/clearing-house/reducers/ClearingHouseReducers.js'
// roundingRuleReducer
import roundingRuleReducer from './../modules/Masters/components/rounding-rule/reducers/RoundingRuleReducers';
import ManageERAReducers from '../modules/ManageERA/reducers/ManageERAReducers.js';
// serviceCode Reducer
import serviceCodeReducer from './../modules/Masters/components/serviceCode/reducers/ServiceCodeReducer';

// Billing Reducer
import billingReducer from './../modules/Billing/components/manageClaims/reducers/ManageClaimReducer';

// Agency Reducer
import agencyReducer from './../modules/Superadmin/components/ManageAgency/reducers/AgencyReducer';
import superadminReportReducer from './../modules/Superadmin/components/Reports/reducers/index';

//Manage Database Reducer
import manageDatabaseReducer from './../modules/Superadmin/components/ManageDataBase/reducers/ManageDataBaseReducer';

// locationMasterReducer
import locationMasterReducer from './../modules/Masters/components/location-master/reducers/LocationMasterReducers';
// custom field reducer
import customFieldReducer from './../modules/Masters/components/customFields/reducers/CustomFieldReducer';
// manage tag reducer
import manageTagReducer from './../modules/Masters/components/manageTags/reducers/ManageTagReducer';
// manage Payer reducer
// import managePayerReducer from './../modules/Payer/reducers/index';
import managePayerReducer from './../modules/Payers/reducers/index';

import appConfigReducer from './../modules/AppConfig/reducers';

// manage tag reducer
import diagnosisReducer from './../modules/Masters/components/diagnosisCode/reducers/DiagnosisReducer';
// appointment-type reducer
import appointmentTypeReducer from './../modules/Masters/components/appointment-type/reducers/AppointmentTypeReducer';

// soap note reducer
import soapReducer from './../modules/scheduling/components/soap/reducers/soapReducer';
import soapReducerHIH from './../modules/scheduling/components/SessionNotes_HIH/reducers/soapReducer';
import nonBillableSoapReducer from './../modules/scheduling/components/nonBillableSoap/reducers/soapReducer';
import customSoapReducer from './../modules/scheduling/components/CustomSessionNotes/reducers/soapReducer';
// Log Reducer
import logReducer from './../modules/Logs/reducers/LogReducer';


// StaffDashboard Reducer
import StaffDashboardReducer from './../modules/Dashboards/reducers/StaffDashboardReducer';

// Patient Portal
import patientPortalReducer from './../modules/PatientPortal/containers/details/reducers';
// Patient Portal Reducer
import PatientPortalDashboardReducer from './../modules/PatientPortal/containers/dashboard/reducers/ClientDashboardReducer';
import PatientPortaManageAppointmentsReducer from './../modules/PatientPortal/containers/ManageAppointments/components/appointments/reducers';
import PatientDataCollectionGraphReducer from './../modules/PatientPortal/containers/DataCollectionGraph/reducers';
// User Roles
import UserRoleReducer from './../modules/Masters/components/userRoles/reducers/UserRoleReducer';
// Insurance Types
import InsuranceReducer from './../modules/Masters/components/insurance-master/reducers/InsuranceReducer';
import NoteReducer from './../modules/Masters/components/note-master/reducers/NoteReducers';
// securityQuestionsReducer
import securityQuestionsReducer from './../modules/SecurityQuestions/reducers/SecurityQuestionsReducer';
//Security Questions
import MasterSecurityQuestionReducer from './../modules/Masters/components/securityQuestions/reducers/SecurityQuestionReducers';

//Role RolePermissions
import RolePermissions from './../modules/Masters/components/role-permission/reducers/RolePermissionReducer';

//Master Document Types
import MasterDocumentTypesReducer from './../modules/Masters/components/masterDocumentTypes/reducers/MasterDocumentTypesReducers';
import MasterDocumentTypesStaffReducer from './../modules/Masters/components/masterDocumentTypesStaff/reducers/MasterDocumentTypesStaffReducers';

import clientLoginReducer from './../modules/PatientPortal/logins/reducers/LoginReducer';
import SuperadminLoginReducer from './../modules/Superadmin/logins/reducers/LoginReducer';

import LedgerReducer from '../modules/Billing/components/Ledger/reducers';

import ReportReducers from '../modules/Reports/reducers';
import MasterTherapyReducer from '../modules/Masters/components/masterTherapy/reducers/MasterTherapyReducer';
import MasterClinicalRoomReducer from '../modules/Masters/components/masterClinicalRoom/reducers/MasterClinicalRoomReducer';

import ManageAppointmentsReducer from '../modules/ManageAppointments/components/appointments/reducers/manageAppointmentReducer';


/* #region Data Collection */
// Maintenance Level Reducer
import MaintenanceLevelsReducer from '../modules/MastersDataCollection/maintenanceLevel/reducers/maintenanceLevelsReducer';
import BehaviorCategoryReducer from '../modules/MastersDataCollection/behaviourCategory/reducers/behaviourCategoryReducer';
// Curriculum Libraries Reducer starts
import CurriculumLibrariesReducer from '../modules/MastersDataCollection/curriculumLibraries/reducers/curriculumLibrariesReducer';
import domainReducer from '../modules/MastersDataCollection/curriculumLibraries/components/domain/reducers/domainReducer';
import programReducer from '../modules/MastersDataCollection/curriculumLibraries/components/program/reducers/programReducer';
import targetReducer from '../modules/MastersDataCollection/curriculumLibraries/components/target/reducers/targetReducer';
// Curriculum Libraries Reducer ends

//skill aquisition starts 
import skillAcquisitionDomain from '../modules/patients/components/DataCollection/SkillAquisition/components/Domain/reducers/skillAquisitionDomainReducer';
import skillAcquisitionProgram from '../modules/patients/components/DataCollection/SkillAquisition/components/Program/reducers/skillAquisitionProgramReducer';
import skillAcquisitionTarget from '../modules/patients/components/DataCollection/SkillAquisition/components/Target/reducers/skillAquisitionTargetReducer';
// skill quisition ends

import dataAnalytics from '../modules/patients/components/DataAnalytics/reducers/dataAnalyticsReducers';
import DCSkillAcquisitionGraphReducer from '../modules/patients/components/DataCollectionGraph/reducers/index';
import DCSkillAcquisitionBatchGraphReducer from '../modules/patients/components/DataCollectionBatchGraph/reducers/index';

import PropmtCodeReducer from '../modules/MastersDataCollection/promptCodes/reducers/PropmtCodeReducer';
import PatientPropmtCodeReducer from '../modules/patients/components/DataCollection/SetUp/promptCodes/reducers/PropmtCodeReducer';
import PatientMasterCriteriaReducer from '../modules/patients/components/DataCollection/SetUp/masteryCriteria/reducers/MasterCriteriaReducer';
import PatientGeneralSettingsReducer from '../modules/patients/components/DataCollection/SetUp/generalSettings/reducers/GeneralSettingsReducer';
import PatientDefaultPhaseChangeLinesReducer from '../modules/patients/components/DataCollection/SetUp/defaultPhaseChangeLines/reducers/DefaultPhaseChangeLinesReducer';
import behaviorReducer from '../modules/patients/components/DataCollection/BehaviorReductiom/Behavior/reducers/behaviorReducer';
import antecedentsReducer from '../modules/patients/components/DataCollection/BehaviorReductiom/Antecedents/reducers/antecedentsReducer';
import consequencesReducer from '../modules/patients/components/DataCollection/BehaviorReductiom/Consequences/reducers/consequencesReducer';
import locationsReducer from '../modules/patients/components/DataCollection/BehaviorReductiom/Locations/reducers/locationsReducer';
import rawABCDataReducer from '../modules/patients/components/DataCollection/BehaviorReductiom/RawABCData/reducers/rawABCDataReducer';
import patientNotes from '../modules/patients/components/collectData/componnets/Notes/reducers/notesReducer';
import patientSkillAcqActiveProgramReducer from '../modules/patients/components/collectData/componnets/SkillAquisition/components/programs/reducers/programsReducer';
import patientSkillAcqActiveTargetReducer from '../modules/patients/components/collectData/componnets/SkillAquisition/components/targets/reducers/targetsReducer';
import PatientBehaviourDataReducer from '../modules/patients/components/collectData/componnets/BehaviorData/reducers/BehaviourDataReducers' 
import PatientDailySummaryDataReducer from '../modules/patients/components/collectData/componnets/DailySummaryData/reducers/DailySummaryReducers.js'

import PatientRecordDurationCustomReducer from '../modules/patients/components/collectData/componnets/BehaviorData/reducers/recordDurationCustomReducer'
import PatientRecordRateCustomReducer from '../modules/patients/components/collectData/componnets/BehaviorData/reducers/recordRateCustomReducer';
import PatientRecordIntervalCustomReducer from '../modules/patients/components/collectData/componnets/BehaviorData/reducers/recordIntervalCustomReducer'
import PatientRecordMomentaryCustomReducer from '../modules/patients/components/collectData/componnets/BehaviorData/reducers/recordMomentaryReducer'
import changePasswordReducer from '../components/changePassword/reducers/changePasswordReducer.js';
/* #endregion */

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_USER_SUCCESS') {
    state = undefined
  }
  return appReducer(state, action)
}

const appReducer = combineReducers({
  form: formReducer,
  notifications: notificationReducers,
  // menu: toggleMenu,
  tableData: tableReducers,
  areaChartData: areaChartReducers,
  lineChartData: lineChartReducers,
  tinyChartData: tinyChartReducers,
  // productsTable: productTableReducers,
  // products: productsReducers,
  // teams: teamReducres,
  // services: serviceReducers,
  // blogs: blogReducers,
  headerStyle: headerStyleReducers,
  headerActiveStyle: headerActiveStyleReducer,
  headerBannerStyle: headerBannerStyleReducers,
  headerBAnnerActiveStyle: headerBannerActiveStyleReducer,
  sidebarStyle: sidebarStyleReducers,
  sidebarActiveStyle: sidebarActiveStyleReducer,
  scheduling: schedulingReducer,
  patient: patientReducer,
  soap: soapReducer,
  customSoap: customSoapReducer,
  soapReducerHIH: soapReducerHIH,
  nonBillableSoap: nonBillableSoapReducer,
  login: loginReducer,
  user: userReducer,
  service_code: serviceCodeReducer,
  billing: billingReducer,
  agency: agencyReducer,
  superadminReport: superadminReportReducer,  
  manageDatabase: manageDatabaseReducer,
  clearing_house: clearingHouseReducer,
  Manage_ERA_Reducer:ManageERAReducers,
  superAdminClearingHouse : superAdminClearingHouseReducer,
  rounding_rule: roundingRuleReducer,
  location_master: locationMasterReducer,
  custom_field: customFieldReducer,
  manage_tag: manageTagReducer,
  payer: managePayerReducer,
  appConfig: appConfigReducer,
  diagnosisCode: diagnosisReducer,
  appointment_type: appointmentTypeReducer,
  logs: logReducer,
  staff_dashboard: StaffDashboardReducer,
  userRoles: UserRoleReducer,
  insuranceType: InsuranceReducer,
  noteType:NoteReducer,
  patientPortal: patientPortalReducer,
  patient_dashboard: PatientPortalDashboardReducer,
  patient_manageAppointments: PatientPortaManageAppointmentsReducer,
  patient_dataCollectionGraph: PatientDataCollectionGraphReducer,  
  security_questions: securityQuestionsReducer,
  mastersecurityQuestions: MasterSecurityQuestionReducer,
  masterDocumentTypes: MasterDocumentTypesReducer,  
  masterDocumentTypesStaff: MasterDocumentTypesStaffReducer,    
  // quick: quickPatientReducer,
  changePassword: changePasswordReducer,
  clientLogin: clientLoginReducer,
  superadminLogin: SuperadminLoginReducer,
  rolePermissions: RolePermissions,
  ledger: LedgerReducer,
  report: ReportReducers,
  masterTherapy: MasterTherapyReducer,
  masterClinicalRoom: MasterClinicalRoomReducer,  
  manageAppointments: ManageAppointmentsReducer,

  /* #region  Data Collection */
  maintenanceLevels: MaintenanceLevelsReducer,
  behaviorCategory: BehaviorCategoryReducer,
  curriculumLibraries: CurriculumLibrariesReducer,
  /* nested Reducers curriculum Libraries starts*/
  domain: domainReducer,
  program: programReducer,
  target: targetReducer,
  /* nested Reducers curriculum Libraries starts */
  prompt_code: PropmtCodeReducer,
  patient_prompt_code: PatientPropmtCodeReducer,
  patient_masterCriteria: PatientMasterCriteriaReducer,
  patient_generalSettings: PatientGeneralSettingsReducer,
  patient_defaultPhaseChangeLines: PatientDefaultPhaseChangeLinesReducer,  
  patient_behavior: behaviorReducer,
  patient_antecedents: antecedentsReducer,
  patient_consequences: consequencesReducer,
  patient_locations: locationsReducer,
  patient_rawABCData: rawABCDataReducer,  

  /* Skill Aquisition starts */
  skillAcquisitionDomain: skillAcquisitionDomain,
  skillAcquisitionProgram: skillAcquisitionProgram,
  skillAcquisitionTarget: skillAcquisitionTarget,
  /* Skill Aquisition ends */
  dataAnalytics: dataAnalytics,
  dcSkillAcquisitionGraph: DCSkillAcquisitionGraphReducer,
  dcSkillAcquisitionBatchGraph: DCSkillAcquisitionBatchGraphReducer,  
  patient_notes : patientNotes,
  patientSkillAcqActiveProgram : patientSkillAcqActiveProgramReducer,
  patientSkillAcqActiveTarget : patientSkillAcqActiveTargetReducer,
  patientBehaviourData: PatientBehaviourDataReducer,
  patientDailySummaryData : PatientDailySummaryDataReducer,
  /* #endregion */
  patientRecordDurationCustomReducer: PatientRecordDurationCustomReducer,
  patientRecordRateCustomReducer: PatientRecordRateCustomReducer,
  patientRecordIntervalCustomReducer: PatientRecordIntervalCustomReducer,
  patientRecordMomentaryCustomReducer: PatientRecordMomentaryCustomReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js